import { withInstall } from '@ll-plus/utils'

import Image from './src/image.vue'
import ImagePreviewGroup from './src/image-preview-group.vue'

export const LlImage = withInstall(Image)
export const LlImagePreviewGroup = withInstall(ImagePreviewGroup)
export default LlImage
export * from './src/image'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlImage: typeof Image
    LlImagePreviewGroup: typeof ImagePreviewGroup
  }
}
